import { render, staticRenderFns } from "./image-text.vue?vue&type=template&id=6ca11088"
import script from "./image-text.vue?vue&type=script&lang=js"
export * from "./image-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca11088')) {
      api.createRecord('6ca11088', component.options)
    } else {
      api.reload('6ca11088', component.options)
    }
    module.hot.accept("./image-text.vue?vue&type=template&id=6ca11088", function () {
      api.rerender('6ca11088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/image-text.vue"
export default component.exports